import moment from "moment";
import { isOneDayPassed } from "./appUtils";

const TRANSACTION_TYPE = {
  SALE: "SALE",
  CAPTURE: "CAPTURE",
  AUTHORIZATION: "AUTHORIZATION"
}

const TRANSACTION_STATE = {
  SUCCESS: "SUCCESS",
}

const PAYMENT_METHOD = {
  CARD: "CARD",
  QR: "QR"
}

const nomuHost = (details) => {
  const transactionState =details.transaction_state?.transaction_state.toUpperCase()
  const transactionType = details.transaction_type?.transaction_type.toUpperCase()
  const paymentMethodName = details.payment_method?.name.toUpperCase()

  const { is_voided, is_refunded, is_captured, transaction_datetime } = details
  const isTxnOneDatePassed = isOneDayPassed(transaction_datetime)

  const isTypeAuthorization = transactionType === TRANSACTION_TYPE.AUTHORIZATION
  const isTypeCapture = transactionType === TRANSACTION_TYPE.CAPTURE
  const isTypeSale = transactionType === TRANSACTION_TYPE.SALE

  const isStateSuccess = transactionState === TRANSACTION_STATE.SUCCESS

  const isAllowMethod = paymentMethodName === PAYMENT_METHOD.CARD || paymentMethodName === PAYMENT_METHOD.QR

  function voidButton() {
    if (!isAllowMethod) return false

    if (isTypeAuthorization && isStateSuccess && !is_voided) {
      return true
    } 

    return false
  }

  function refundButton() {
    if (!isAllowMethod) return false

    if (isStateSuccess && isTxnOneDatePassed) {

      if (isTypeSale && !is_refunded) {
        return true
      }
      
      if (isTypeCapture /* && !is_refunded */) {
        return true
      }
    }

    return false
  }

  function captureButton() {
    if (!isAllowMethod) return false

    if (isTypeAuthorization && isStateSuccess && !is_captured && !is_voided) {
      return true
    }

    return false
  }

  function showButton(type) {
    switch (type) {
      case 'void':
        return voidButton()
      case 'refund':
        return refundButton()
      case 'capture':
        return captureButton()
      default:
        break;
    }
  }

  return {
    showButton
  }
}

export const canBeVoided = (details) => {
  return details.is_allow_void;
};

export const canBeChargeBacked = (details) => {
  let transactionState = details.transaction_state?.transaction_state;
  let transactionType = details.transaction_type?.transaction_type;
  if (
    transactionState === "DENIED" ||
    transactionState === "ORDER_CLOSED" ||
    transactionState === "USER_PAYING" ||
    transactionState === "REFUNDED" ||
    transactionState === "PENDING" ||
    transactionState === "VOIDED" ||
    transactionType === "REFUND" ||
    transactionType === "CHARGEBACK" ||
    transactionType === "VOID" ||
    transactionType === "REVOKE_ORDER" ||
    details.action_done
  )
    return false;
  else if (
    details.payment_brand.name.toLowerCase() === "diners" &&
    !details.void_valid
  )
    return true;
  else if (!details.void_valid && details.card_number) return true;
  return false;
};

export const canBeRefunded = (details) => {
  return details.is_allow_refund;
};

export const canBeCanceled = (details) => {
  let transactionState =
    details.transaction_state?.transaction_state.toUpperCase();
  let transactionType =
    details.transaction_type?.transaction_type.toUpperCase();
  let paymentMethodName = details.payment_method.name.toUpperCase();

  if (transactionType === "SALE" && paymentMethodName === "QR") {
    if (transactionState === "PENDING" || transactionState === "ERROR") {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};

export const canBeCaptured = (details) => {
  let transactionState =
    details.transaction_state?.transaction_state.toUpperCase();
  let transactionType =
    details.transaction_type?.transaction_type.toUpperCase();
  let paymentMethodName = details.payment_method.name.toUpperCase();
  let paymentHost = details.payment_host?.name.toLowerCase()

  if (paymentHost.includes('nomu')) {
    const initNomuHost = nomuHost(details)
  
    return initNomuHost.showButton('capture')
  }

  if (
    (transactionType === "CAPTURE" && transactionState === "PENDING") ||
    (transactionType === "CAPTURE" && transactionState === "ERROR") ||
    (transactionType === "AUTHORIZE" && transactionState === "SUCCESS")
  ) {
    return true;
  }
  return false;
};

export const canBeAuthorized = (details) => {
  let transactionState = details.transaction_state?.transaction_state;
  let transactionType = details.transaction_type?.transaction_type;
  if (transactionType === "AUTHORIZE" && transactionState === "PENDING") {
    return true;
  }
  return false;
};

export const canBePlanSelected = (details) => {
  // STATE = SUCCESS
  // TYPE = CAPTURE
  // HOST NAME = WORLDPAY
  // B PLAN ID = true

  let transactionState = details.transaction_state?.transaction_state;
  let transactionType = details.transaction_type?.transaction_type;
  if (
    transactionType === "CAPTURE" &&
    transactionState === "SUCCESS" &&
    details.payment_host.name.toLowerCase() === "worldpay" &&
    details.b_plan_id
  ) {
    return true;
  }
  return false;
};
